import React from 'react'
// import Checkbox from './Checkbox';
import Modal from './Modal'
import OtpPopupCon from '$Deposits/Components/Components/OtpPopup'

export class OtpPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };

    }
    componentWillUnmount() {

    }


    render() {

        return (
            <>
                <OtpPopupCon
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                />
            </>
        )
    }
}


export default OtpPopup
